import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'isOpen',
})
export class IsOpenPipe implements PipeTransform {
  transform(locations: any, currentDay: any) {
    return locations.filter(location => {
      const d = moment(currentDay).day();
      return location.hours[d].start !== location.hours[d].end;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/is-open/is-open.ts